"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var table_dom_traversal_1 = require("./browser/table-dom-traversal");
var virtual_worksheet_1 = require("./virtual-worksheet");
var validFocusable = "input:not([type=checkbox]):not([disabled=disabled])," +
    "[tabindex]:not([disabled=disabled])";
var traverser = new table_dom_traversal_1.TableDomTraverser(isValidTableCell);
function isVisible(el) {
    var isHidden = false;
    var parentElement = el;
    do {
        isHidden = getComputedStyle(parentElement).display === "none";
        parentElement = parentElement.parentElement;
    } while (!isHidden && parentElement);
    return !isHidden;
}
function isValidTableCell(cell) {
    if (!cell) {
        return true;
    }
    var input = cell.querySelector(validFocusable);
    if (input === null) {
        return false;
    }
    return isVisible(input);
}
var defaultOptions = {
    validInputSelector: validFocusable,
    inputValidators: [function (_) { return true; }]
};
var tableContexts = {};
var idWarned = false;
function attachToTable(table, options) {
    if (options === void 0) { options = defaultOptions; }
    options = Object.assign({}, defaultOptions, options);
    var worksheetOptions = {
        inputSelector: options.validInputSelector,
        inputValidator: function (el) { return options.inputValidators.reduce(function (all, validator) {
            return all && validator(el);
        }, true); }
    };
    if (!table.id && !idWarned) {
        console.warn("Attaching sheet hotkeys to table without an id could lead to quirks. " +
            "Consider assigning an ID or managing the worksheet lifetime manually using VirtualWorksheet");
        idWarned = true;
    }
    var worksheet = tableContexts[table.id] = new virtual_worksheet_1.VirtualWorksheet(table, traverser, worksheetOptions);
    worksheet.attachToTable();
}
exports.attachToTable = attachToTable;
function detachFromTable(table) {
    var worksheet = tableContexts[table.id];
    if (worksheet !== undefined) {
        worksheet.detachFromTable();
    }
}
exports.detachFromTable = detachFromTable;
